import {GetExamsProviderLocationAccreditedParams} from 'domain/usecases/private/booking-flow/exams/get-exams-provider-location-accredited';
import {makeGetExamsProviderLocationAccredited} from 'main/factories/usecases/private/booking-flow/remote-exams-booking/get-exams-provider-location-accredited-factory';
import {parseExamAccreditedUnits} from '../../utils/parseExamAccreditedUnits';

async function getExamsAccreditedUnits(params: GetExamsProviderLocationAccreditedParams) {
	const response = await makeGetExamsProviderLocationAccredited().get(params);

	if (!response) {
		return {redeCredenciada: []};
	}

	const parsedUnits = parseExamAccreditedUnits(response.redeCredenciada);

	return {
		redeCredenciada: parsedUnits,
	};
}

export {getExamsAccreditedUnits};
